import { IComponentsNames } from '@thryveai/theme-interfaces';
import ProductImage from './ProductImage';
import ProductPrice from './ProductPrice';
import PromotionLabel from './PromotionLabel';
import FavoritesButton from './FavoritesButton';
import PastPurchased from './PastPurchased';
import ProductName from './ProductName';
import AddToCartButton from './AddToCartButton';
import ProductWasPrice from './ProductWasPrice';
import ProductUnitPrice from './ProductUnitPrice';
import ShoppingRulesLabel from './ShoppingRulesLabel';
import ProductCoupons from './ProductCoupons';
import ProductAttributes from './ProductAttributes';
import RecommendedLabel from './RecommendedLabel';
import ViewDealButton from './ViewDealButton';
import SponsoredLabel from './SponsoredLabel';
import OfferValidMessage from './OfferValidMessage';
import ProductPriceLoyalty from './ProductPriceLoyalty';
import TaxDetails from './TaxDetails';
import ProductWasUnitPrice from './ProductWasUnitPrice';
import ProductWeightBased from './ProductWeightBased';

export type SvgComponentRegistry = {
  [key in IComponentsNames]?: any;
};

export const svgComponents = {
  ProductImage,
  ProductPrice,
  PromotionLabel,
  FavoritesButton,
  PastPurchased,
  ProductName,
  AddToCartButton,
  ProductWasPrice,
  ProductUnitPrice,
  ProductWeightBased,
  ShoppingRuleLabels: ShoppingRulesLabel,
  ProductCoupons,
  ProductAttributes,
  RecommendedLabel,
  ViewDealButton,
  SponsoredLabel,
  OfferValidMessage,
  ProductPriceLoyalty,
  TaxDetails,
  ProductWasUnitPrice,
};
